"use client";

import { c as _c } from "react/compiler-runtime";
import { useCookieConsent } from "@/components/cookies/CookieConsentContext";
import { useSetTitle } from "@/contexts/TitleContext";
import useCapacitor from "@/hooks/useCapacitor";
import { BellIcon, ChartBarIcon, CurrencyDollarIcon, SparklesIcon, UserGroupIcon } from "@heroicons/react/24/outline";
import Link from "next/link";
import type { ReactNode } from "react";
interface DownloadCardProps {
  readonly href: string;
  readonly title: string;
  readonly icon: ReactNode;
}
function DownloadCard(t0) {
  const $ = _c(9);
  const {
    href,
    title,
    icon
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="tw-absolute tw-inset-0 tw-rounded-xl tw-bg-gradient-to-br tw-from-white/0 tw-to-white/0 tw-transition-opacity tw-duration-300 desktop-hover:group-hover:tw-from-white/5 desktop-hover:group-hover:tw-to-white/0" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== icon) {
    t2 = <div className="tw-relative tw-flex tw-items-center tw-justify-center tw-w-10 tw-h-10 tw-text-white desktop-hover:group-hover:tw-scale-110 tw-transition-transform tw-duration-300">{icon}</div>;
    $[1] = icon;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== title) {
    t3 = <span className="tw-relative tw-text-lg tw-font-semibold tw-text-white tw-transition-colors tw-duration-300 desktop-hover:group-hover:tw-text-iron-100">{title}</span>;
    $[3] = title;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== href || $[6] !== t2 || $[7] !== t3) {
    t4 = <Link href={href} className="tw-group tw-relative tw-flex tw-items-center tw-gap-4 tw-rounded-xl tw-border tw-border-solid tw-border-white/10 tw-bg-gradient-to-br tw-from-iron-950 tw-to-iron-900/50 tw-px-6 tw-py-4 tw-h-24 tw-w-full sm:tw-max-w-2xl sm:tw-mx-auto tw-shadow-sm tw-shadow-black/20 tw-transition-all tw-duration-300 tw-ease-out tw-no-underline desktop-hover:hover:tw-border-white/20 desktop-hover:hover:tw-shadow-lg desktop-hover:hover:tw-shadow-black/40 desktop-hover:hover:tw-translate-y-[-2px] focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-primary-500">{t1}{t2}{t3}</Link>;
    $[5] = href;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}
export default function CommunityDownloads() {
  const $ = _c(12);
  const capacitor = useCapacitor();
  const {
    country
  } = useCookieConsent();
  useSetTitle("Open Data");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      href: "/open-data/network-metrics",
      title: "Network Metrics",
      icon: <ChartBarIcon className="tw-w-full tw-h-full" />
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== capacitor.isIos || $[2] !== country) {
    t1 = !capacitor.isIos || country === "US" ? [{
      href: "/open-data/meme-subscriptions",
      title: "Meme Subscriptions",
      icon: <BellIcon className="tw-w-full tw-h-full" />
    }] : [];
    $[1] = capacitor.isIos;
    $[2] = country;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      href: "/open-data/rememes",
      title: "Rememes",
      icon: <SparklesIcon className="tw-w-full tw-h-full" />
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      href: "/open-data/team",
      title: "Team",
      icon: <UserGroupIcon className="tw-w-full tw-h-full" />
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      href: "/open-data/royalties",
      title: "Royalties",
      icon: <CurrencyDollarIcon className="tw-w-full tw-h-full" />
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t1) {
    t5 = [t0, ...t1, t2, t3, t4];
    $[7] = t1;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const items = t5;
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="tw-mb-12"><h1>Open Data</h1></div>;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== items) {
    t7 = <div className="tw-container tw-mx-auto tw-px-4 tw-py-4 sm:tw-px-6 lg:tw-px-8">{t6}<div className="tw-flex tw-flex-col tw-gap-4">{items.map(_temp)}</div></div>;
    $[10] = items;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
}
function _temp(item) {
  return <DownloadCard key={item.href} href={item.href} title={item.title} icon={item.icon} />;
}